import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const app = initializeApp({
  apiKey: "AIzaSyB4NyLakT85a7uPv-NyCJw866k--UMij1c",
  authDomain: "blisterflow.firebaseapp.com",
  projectId: "blisterflow",
  storageBucket: "blisterflow.firebasestorage.app",
  messagingSenderId: "492552903599",
  appId: "1:492552903599:web:ca64772ee4307a40bdad5a"
});

export const db = getFirestore(app, 'blisterflow');
export const auth = getAuth(app);
export const functions = getFunctions(app, 'northamerica-northeast2');
export { app };
